<template>
  <main-layout>
    <template slot="header-title">{{ $t('libraries.title') }}</template>

    <template slot="header-actions">
      <common-button
        @click="openLibraryCreation = true">Create a library</common-button>
    </template>

    <template slot="main">
      <div class="container mx-auto">
        <div class="libraries-list">
          <div v-if="loading" v-loading="true"></div>
          <div v-else v-for="library in librariesSorted" v-bind:key="library.id">
            <library :id="library.id"></library>
          </div>
        </div>
        <library-form v-if="openLibraryCreation" :open="openLibraryCreation" @close="closeLibraryCreation"></library-form>
      </div>
    </template>
  </main-layout>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import library from '@/components/libraries/library.vue'
import LibraryForm from '@/components/libraries/library-form.vue'

export default {
  components: { library, LibraryForm },
  data () {
    return {
      loading: true,
      openLibraryCreation: false
    }
  },
  computed: {
    ...mapGetters('libraries', {
      libraries: 'libraries'
    }),
    ...mapGetters('account', {
      site: 'currentSite'
    }),

    librariesSorted () {
      return this.libraries.slice().sort(function (a, b) {
        return b.id - a.id
      })
    }
  },
  watch: {
    site: function () {
      this.initLibrariesList()
    }
  },
  methods: {
    ...mapActions('libraries', ['addLibrary', 'removeLibrary', 'loadLibraries']),
    ...mapActions('medias', ['loadMedias']),

    initLibrariesList () {
      if (this.site) {
        this.loadLibraries(this.site.sitekey).then(() => {
          this.loading = false
        })
      }
    },
    closeLibraryCreation () {
      this.openLibraryCreation = false
    }
  },
  mounted () {
    this.initLibrariesList()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Library/LibraryList.vue